module.exports = __webpack_public_path__ + "img/header-logo.c84d93c4.png";